module.exports = __webpack_public_path__ + "img/logo20.96da37d9.png";